import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '@diggens/user-management';

/** Where `/` and old `/home` links land: super admins on Tenants, everyone else on /dashboard, the Chief of Staff for an admin and the portco dashboard for a portco user. */
export function Landing() {
  const { data: user } = useCurrentUser();

  // ProtectedRoute renders this only once the user has loaded
  if (!user) return null;
  return <Navigate to={user.role === 'super_admin' ? '/super-admin/tenants' : '/dashboard'} replace />;
}
